import React from "react";

/**
 * @component PencilSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <PencilSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PencilSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={12}
      height={12}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PencilSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M9 3.47L2.46 10H2v-.46L8.53 3l.47.47zM9.98.145l-.915.915 1.875 1.875.915-.915a.498.498 0 000-.705l-1.17-1.17a.5.5 0 00-.705 0zm-1.45 1.45L1 9.125V11h1.875l7.53-7.53L8.53 1.595z"
        fillRule="evenodd"
      />
    </svg>
  )
);
PencilSmallIcon.displayName = "PencilSmallIcon";
export default PencilSmallIcon;
